import clsx from 'clsx'
import isString from 'lodash/isString'
import React, { CSSProperties, FC, memo, PropsWithChildren, ReactNode } from 'react'

import { NavLinkClickProperties } from '@Analytics/ampli'
import SvgAngleRight from '@Assets/SVG/AngleRight'
import { Link } from '@Components/Link'

import styles from './HeaderWithTextLineItem.module.scss'

interface HeaderWithTextLineItemProps {
  analytics?: NavLinkClickProperties
  borderColor?: string
  className?: string
  header: string | ReactNode
  href?: string
  label?: string | ReactNode
  onClick?: (event: React.MouseEvent) => void
  onHover?: (hover: boolean, event: React.MouseEvent) => void
  style?: CSSProperties
  textColor?: string
}
export const HeaderWithTextLineItem: FC<PropsWithChildren<HeaderWithTextLineItemProps>> = memo(({ analytics,
  borderColor,
  children,
  className,
  header,
  href,
  label,
  onClick,
  onHover,
  style,
  textColor }) => {
  const exStyles: CSSProperties = {
    '--borderColor': borderColor || 'var(--neutral-200)',
    '--textColor': textColor || 'var(--black)',
    ...style,
  } as CSSProperties

  const content = (
    <div className={styles.column}>
      <div className={styles.headerAndText}>
        {isString(header) ? <h3 className={styles.header}>{header}</h3> : <div className={styles.header}>{header}</div>}
        <div className={styles.text}>{children}</div>
      </div>
      {isString(label)
        ? (
          <span className={styles.label}>
            {(href || onClick) && <SvgAngleRight />}
            {label}
          </span>
        )
        : label}
    </div>
  )

  if (href) {
    return (
      <Link
        analytics={analytics}
        className={clsx(styles.headerWithTextLineItem, className)}
        href={href}
        onClick={onClick}
        onMouseEnter={e => (onHover ? onHover(true, e) : undefined)}
        onMouseLeave={e => (onHover ? onHover(false, e) : undefined)}
        style={exStyles}
      >
        {content}
      </Link>
    )
  }
  if (onClick) {
    return (
      <button
        className={clsx(styles.headerWithTextLineItem, className)}
        onClick={onClick}
        onMouseEnter={e => (onHover ? onHover(true, e) : undefined)}
        onMouseLeave={e => (onHover ? onHover(false, e) : undefined)}
        style={exStyles}
        type="button"
      >
        {content}
      </button>
    )
  }
  return (
    <div
      className={clsx(styles.headerWithTextLineItem, className)}
      onMouseEnter={e => (onHover ? onHover(true, e) : undefined)}
      onMouseLeave={e => (onHover ? onHover(false, e) : undefined)}
      style={exStyles}
    >
      {content}
    </div>
  )
}, (prev, curr) => prev.borderColor === curr.borderColor)
